/**
 * Work Bright Gateway API
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChangeDetectorRef, Injectable, OnDestroy } from '@angular/core';

// import { PnApiClientService, PnStorageService } from '@postnerd-core';
import { Observable, Subscription } from 'rxjs';

import * as _ from 'lodash';

import { LanguageEnum } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { CoreTranslateService } from 'pn-core-code';

export interface InitItemDto {
  title: string;
}
@Injectable({
  providedIn: 'root',
})
export class InitialNameService {
  currentLang: string;
  initTitle: InitItemDto = {} as InitItemDto;
  changes$$: Subscription;
  constructor(
    private translateService: TranslateService,
    private coreTranslateService: CoreTranslateService,
    private cdr: ChangeDetectorRef,
  ) {

    this.translateService.onLangChange.subscribe(t => {
      this.currentLang = t.lang;
    });
  }



  initName(translationData: any, attr?: string | any): any {
    this.currentLang = this.translateService.currentLang;
    let resultObject: any = _.find(translationData?.translations, v => v.language === (this.currentLang || LanguageEnum.Th))
    // console.log('resultObject', resultObject);
    if (!_.isEmpty(resultObject)) {
      // console.log('resultObject', resultObject[attr]);
      return resultObject[attr || 'name'] || null
    } else {
      return '-';
    }

  }

  covertObjectTranslations(translation: any[], languageAttr: string = LanguageEnum.Th) {
    let resultObject: any = _.find(translation, v => v.language === (languageAttr))
    // console.log('resultObject 60', resultObject);
    return !_.isEmpty(resultObject) ? resultObject : {};
  }
}
